const shippingStatusReasonSettingsModel = vm => ({
  title: vm.$gettext('Shipping Status Reason Settings'),
  endpoint: 'shipping-status-reason-settings',
  allowNew: true,
  allowDelete: true,
  shared: false,
  countrize: 'country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'shipping_status_reasons_id',
      label: vm.$gettext('Shipping Status Reason'),
      sortable: true,
      editable: false,
      required: true,
      description: vm.$gettext(
        'Foreign Key to shipping status reasons table which defines when this happens and why'
      ),
      type: 'select',
      options: 'shippingStatusReasons'
    },
    {
      key: 'country_iso_code',
      label: vm.$gettext('Country'),
      sortable: true,
      editable: false,
      required: true,
      description: vm.$gettext('ISO Code pointing to countries, to which country this setting applies for'),
      type: 'select',
      options: 'countries',
      withSelect: true
    },
    {
      key: 'relationship',
      label: vm.$gettext('Relationship'),
      sortable: false,
      editable: false,
      required: true,
      description: vm.$gettext(
        'To which type of transaction this rule applies. Must be one of: <strong>client</strong> or <strong>provider</strong>'
      ),
      type: 'select',
      options: [
        { text: vm.$gettext('Client'), value: 'client' },
        { text: vm.$gettext('Provider'), value: 'provider' }
      ]
    },
    {
      key: 'min_tour_shippings',
      label: vm.$gettext('Minimum Tour Shippings'),
      sortable: false,
      editable: true,
      required: true,
      description: vm.$gettext(
        'In case of shippings belonging to a tour, from how many shippings this setting applies for, otherwise should be 0 (zero)'
      )
    },
    {
      key: 'percentage',
      label: vm.$gettext('Percentage'),
      sortable: false,
      editable: true,
      required: true,
      description: vm.$gettext(
        '0 to 100, which percentage of the total shipping price/commission should apply'
      )
    }
  ],
  filters: ['id', 'shipping_status_reasons_id', 'relationship', 'country_iso_code']
})

export default shippingStatusReasonSettingsModel
